module.exports = __webpack_public_path__ + "de73b012a435587a99557c9b4151287b.svg";